
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/other-insurances",
      function () {
        return require("private-next-pages/products/other-insurances/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/other-insurances"])
      });
    }
  